<div class="wrapper">
    <div class="content-wrapper">
        @for (tab of tabMapFilters(); track tab) {
            <ng-container *ngTemplateOutlet="tabItem; context: {tab, tabIndex: 0}"></ng-container>
        }
    </div>
</div>

<ng-template #tabItem let-tab="tab" let-tabIndex="tabIndex">
    <div
        class="filter-results-item"
        [attr.data-testid]="tab.testId"
        (click)="handleClick(tab)"
        [class.selected]="isTabSelected(tab)"
    >{{ tab.name }}</div>
</ng-template>
